module.exports = "<div class=\"row h-100\">\n   <div class=\"col-lg-10 col-md-12 h-100 pl-0 pr-0\">\n      <div class=\"w-100 pr-1\">\n         <app-game-state></app-game-state>\n      </div>\n      <router-outlet></router-outlet>\n   </div>\n   <div class=\"col-2 h-100 pl-0 pr-0 hidden-md-down\">\n      <app-log-history class=\"mw-100 p-0 hidden-md-down\"></app-log-history>\n   </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/web/game/game.component.html
// module id = ./src/app/web/game/game.component.html
// module chunks = main